<div class="modal-header" *transloco="let t; read: 'ime.manufacturing.integrated-master-editor'" ngxModalDraggable>
  <h4 class="modal-title pull-left">{{code}}</h4>
  <div class="ms-auto">
    <button type="button" class="btn btn-outline-primary me-2" [ngClass]="{'active': arePropertiesShown}" aria-label="Toggle properties"
            (click)="arePropertiesShown = !arePropertiesShown">
      {{t('Properties')}}
    </button>
    <button type="button" class="btn btn-outline-primary me-2" [ngClass]="{'active': areInValidLinesShown}" aria-label="Toggle invalid lines"
            (click)="areInValidLinesShown = !areInValidLinesShown">
      {{t('Invalid lines')}}
    </button>
    <button *ngIf="hasCostButton" type="button" class="btn btn-outline-primary" aria-label="Show cost"
            (click)="showCost()">
      {{t('Cost')}}
    </button>
  </div>
  <button type="button" class="btn-close ms-2" aria-label="Close" (click)="bsModalRef.dismiss()">
  </button>
</div>
<div class="modal-body">
  <form id="container-lines-form" *ngIf="arePropertiesShown">
    <div class="d-flex flex-wrap mb-2">
      <div *ngFor="let group of specs | groupBy: 'PropertyId' | values | orderBy: 'length'"
           class="border" [class.d-flex]="group.length > 1" [class.w-100]="group.length > 1" [class.w-16]="group.length === 1">
        <div *ngFor="let line of group | orderBy: 'LanguageId'" [class.w-16]="group.length > 1">
          <web-spec-value [spec]="line" [readonly]="readonly" [showLabel]="true"></web-spec-value>
        </div>
      </div>
    </div>
<!--    <div class="d-flex flex-wrap mb-2">-->
<!--      <div *ngFor="let group of specs | groupBy: 'PropertyId' | values | orderBy: 'length'"-->
<!--           class="border" [class.flex-row]="group.length > 1" [class.d-flex]="group.length > 1" [class.w-100]="group.length > 1" [class.w-16]="group.length === 1">-->
<!--        <div *ngFor="let line of group | orderBy: 'LanguageId'" [class.w-16]="group.length > 1">-->
<!--          <web-spec-value [spec]="line" [readonly]="readonly" [showLabel]="true"></web-spec-value>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </form>
  <form>
    <mes-web-integrated-master-editor [masterOperations]="masterOperations"
                                      [processSelectors]="processSelectors"
                                      [allowItemGroupsAsInputs]="allowItemGroupsAsInputs"
                                      [validConditionFilter]="areInValidLinesShown ? null : 'True'"
                                      [readonly]="readonly"
                                      [showPhantoms]="showPhantoms"
                                      (onShowIme)="showIme($event)">
    </mes-web-integrated-master-editor>
  </form>
</div>


